import { range } from './range';
export function randomString(length) {
    var characterSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var randomChar = function () {
        return characterSet[Math.floor(Math.random() * characterSet.length)];
    };
    return range(0, length).reduce(function (text) { return text + randomChar(); }, '');
}
